const hasSemicolonInName = (client: any) => {
  if (client && client.displayName && client.displayName.includes(':')) {
    return true;
  }
  return false;
};

export { hasSemicolonInName };
